import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthLoadingScreen from "../../components/AuthLoadingScreen";
import authService from "../../services/authService";

function LogoutUI() {
  const { t } = useTranslation();

  useEffect(() => {
    void authService.logout();
  }, []);

  return <AuthLoadingScreen message={t("auth.loggingOut")} />;
}

export default LogoutUI;
